var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-filters"},[_c('FilterInputs',{ref:"filterPanelSelects",staticClass:"mobile-filters__selects"},[_c('MobileClearFilters')],1),_c('TotemToast',{ref:"toast"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }